import { render } from "./Extras.vue?vue&type=template&id=4850af30&scoped=true&ts=true"
import script from "./Extras.vue?vue&type=script&lang=ts"
export * from "./Extras.vue?vue&type=script&lang=ts"

import "./Extras.vue?vue&type=style&index=0&id=4850af30&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4850af30"]])

export default __exports__